/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

/**
 * The third party systems
 */
export enum TpsEnum {
  DA = "DA",
  KSR = "KSR",
  GCS = "GCS",
  ECAROS = "ECAROS",

  /**
   * SilverDAT 3 valuateFinance
   */
  DAT_FINANCE_LINE = "DAT_FINANCE_LINE",

  /**
   * SilverDAT 3 valuateExpert
   */
  DAT_VALUATE_NG = "DAT_VALUATE_NG",

  /**
   * SilverDAT calculatePro / SilverDAT calculateExpert
   */
  DAT_VEHICLE_REPAIR_ONLINE = "DAT_VEHICLE_REPAIR_ONLINE",

  /**
   * SilverDAT®3 myclaim
   */
  DAT_MY_CLAIM = "DAT_MY_CLAIM"
}
